import { EyeOff } from 'lucide-react';

import { isPresentationMode, setPresentationMode } from '../../lib/presentationMode';

/**
 * While the presentation mode is on (lib/presentationMode.ts), a pill at the foot of every screen says so and
 * turns it off in one click: whoever shows the application always knows the figures are hidden.
 */
export function PresentationModeBadge() {
  if (!isPresentationMode()) return null;
  return (
    <div
      role="status"
      className="fixed bottom-3 left-1/2 z-[100] flex -translate-x-1/2 items-center gap-2 rounded-full border border-neutral-200 bg-white/95 py-1 pl-3 pr-1 text-xs text-neutral-700 shadow-md backdrop-blur dark:border-neutral-700 dark:bg-neutral-900/95 dark:text-neutral-200 print:hidden"
    >
      <EyeOff size={14} aria-hidden="true" />
      <span>Mode présentation : chiffres masqués</span>
      <button
        type="button"
        onClick={() => setPresentationMode(false)}
        className="rounded-full px-2 py-0.5 font-medium text-neutral-900 hover:bg-neutral-100 dark:text-white dark:hover:bg-neutral-800"
      >
        Quitter
      </button>
    </div>
  );
}

/**
 * Shown instead of the application when the masks of the presentation mode could not load: the application would
 * otherwise draw its real figures to the person it is shown to.
 */
export function PresentationMaskUnavailable() {
  return (
    <main className="flex min-h-screen items-center justify-center bg-neutral-50 p-6 dark:bg-neutral-950">
      <div className="max-w-sm text-center text-sm text-neutral-700 dark:text-neutral-200">
        <EyeOff size={20} className="mx-auto mb-3 text-neutral-400" aria-hidden="true" />
        <p className="font-medium text-neutral-900 dark:text-white">Le masque des chiffres n’a pas pu se charger</p>
        <p className="mt-1">L’application reste cachée pour ne montrer aucun chiffre. Rechargez la page, ou quittez le mode présentation.</p>
        <div className="mt-4 flex justify-center gap-2">
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="rounded-lg bg-neutral-900 px-3 py-1.5 font-medium text-white hover:bg-neutral-800 dark:bg-white dark:text-neutral-900"
          >
            Recharger
          </button>
          <button
            type="button"
            onClick={() => setPresentationMode(false)}
            className="rounded-lg px-3 py-1.5 font-medium text-neutral-700 hover:bg-neutral-200 dark:text-neutral-200 dark:hover:bg-neutral-800"
          >
            Quitter le mode présentation
          </button>
        </div>
      </div>
    </main>
  );
}
